import { createVariant } from '../../utils/createVariant';
export const PriceTextXl = createVariant({
    name: 'price-text-xl',
    tagName: 'span',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, theme.typography.numbersPricesAndUsPs['500PriceTextXlMobile']), { color: theme.colors.base.textPrice, display: 'inline-block' })),
    responsiveStyles: ({ theme }) => [
        [theme.viewportBreakpoint.lg, theme.typography.numbersPricesAndUsPs['500PriceTextXl']],
    ],
});
